import { AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { formatCurrency } from 'utils';
import { Nullable } from 'global';
import { dealSummaryGetEquipmentTitle } from '../../../../lib';
import { DealBuilderEquipmentSource } from '../../../../types';
import { DealBuilderQuote } from '../../../../api';
import { FlatAccordion } from './FlatAccordion';
import { PriceField } from './PriceField';

interface Props {
  quote: Nullable<DealBuilderQuote>;
  equipmentData: Nullable<DealBuilderEquipmentSource[]>;
}

export const TradeInSection = ({ quote, equipmentData }: Props) => (
  <FlatAccordion disableGutters>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" flex={1} pr={1}>
        <Typography fontWeight={500}>Trade-In</Typography>
        <Typography variant="body2" color="text.secondary" fontWeight={400}>
          {formatCurrency(quote?.tradeValueNet ?? 0, true)}
        </Typography>
      </Stack>
    </AccordionSummary>
    <AccordionDetails>
      <Stack gap={1.5}>
        {!quote?.equipmentTradeIns?.length && <Typography color="text.secondary">No trade-in equipment.</Typography>}
        {(quote?.equipmentTradeIns ?? []).map(tradeIn => (
          <Box key={tradeIn.equipmentId} p={1.5} borderRadius={1} border={1} borderColor="grey.200" bgcolor="#f7f8fa">
            <Typography variant="body1">{dealSummaryGetEquipmentTitle(tradeIn, equipmentData)}</Typography>
            <Stack direction="row" justifyContent="space-between" gap={2} mt={0.5}>
              <PriceField label="Trade Value" value={tradeIn.tradeInDetails.tradeValue} />
              <PriceField label="Amount Owed" value={tradeIn.tradeInDetails.tradeAmountOwed} />
            </Stack>
          </Box>
        ))}
      </Stack>
    </AccordionDetails>
  </FlatAccordion>
);
